<template>
  <div class="core-tech pa-10">
<!--    <div class="py-15 d-flex justify-center align-center card-title">-->
<!--      核心技术能力-->
<!--    </div>-->
    <div class="core-outer">
      <!--流程图-->

      <div class="core-card">
        <div class="step-text d-flex justify-space-between align-center pt-9">
          <v-img
            contain
            :src="require('../../../../assets/pc/index/smart/bar.png')"
            :lazy-src="require('../../../../assets/pc/index/smart/bar.png')"
          ></v-img>
        </div>
        <div style="width: 100%" class="d-flex justify-space-between">
          <template v-for="(item, index) in dataArr">
            <div :key="index" class="core-row">
              <core-tech-row :item="item"></core-tech-row>
            </div>
          </template>
<!--          <div class="core-row">-->
<!--            <core-tech-row></core-tech-row>-->
<!--          </div>-->
<!--          <div class="core-row">2</div>-->
<!--          <div class="core-row">3</div>-->
<!--          <div class="core-row">4</div>-->
        </div>
<!--        <v-row>-->
<!--          <v-col :cols="3" style="background-color: #0d47a1">-->
<!--            <core-tech-row></core-tech-row>-->
<!--          </v-col>-->
<!--          <v-col :cols="3">-->
<!--            <core-tech-row></core-tech-row>-->
<!--          </v-col>-->
<!--          <v-col :cols="3">3</v-col>-->
<!--          <v-col :cols="3">4</v-col>-->
<!--        </v-row>-->
      </div>
    </div>
  </div>
</template>

<script>
import CoreTechRow from './coreTechRow.vue'
import row1 from '../../../../assets/pc/index/smart/row1.png'
import row2 from '../../../../assets/pc/index/smart/row2.png'
import row3 from '../../../../assets/pc/index/smart/row3.png'
import row4 from '../../../../assets/pc/index/smart/row4.png'
export default {
  name: 'core-tech',
  components: {
    CoreTechRow
  },
  data () {
    return {
      dataArr: [
        {
          arrow: false,
          arr: [
            {image: '', text: '大语言模型'},
            {image: row1, text: ''},
            {image: row2, text: ''},
            {image: row3, text: ''},
            {image: '', text: '自研中型自然语言模型'},
            {image: row4, text: ''}
          ]
        },
        {
          arrow: false,
          arr: [
            {image: '', text: '遵循临床试验方案'},
            {image: '', text: '内容完整且简明'},
            {image: '', text: '设计指标意义明确'},
            {image: '', text: '方便填写及录入'},
            {image: '', text: '尽量避免衍生数据'},
            {image: '', text: '易于归档与统计分析'}
          ]
        },
        {
          arrow: true,
          arr: [
            {image: '', text: '回顾性研究'},
            {image: '', text: '方法验证'},
            {image: '', text: '统计分析'},
            {image: '', text: '方法创新'},
            {image: '', text: '前瞻性研究'},
            {image: '', text: '统计分析'}
          ]
        },
        {
          arrow: false,
          arr: [
            {image: '', text: 'Paper'},
            {image: '', text: '著作'},
            {image: '', text: '专利'},
            {image: '', text: '软件'},
            {image: '', text: '新产品'},
            {image: '', text: '新技术'}
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.core-tech {
  background: white;
  margin: 20px auto;
}

.card-title {
  height: 66px;
  font-weight: 500;
  font-size: 30px;
}

.tech-img {
  position: absolute;
  max-height: 700px;
  left: 0;
  top: 40px;
}

.core-outer {
  background: #fff;
  box-shadow: 0 5px 35px 0 rgba(0, 16, 99, 0.15);
  border-radius: 8px;
  max-width: 1500px;
  margin: auto;
}

.step-text {
  width: 90%;
  margin: auto;
  position: absolute;
  top: 10px;
  left: 30px;
}
.core-row {
  height: 700px;
  width: 24%;
  margin-top: 40px;
  background-color: #F7F7F7;
  padding-top: 130px;
}

.core-card {
  width: 1200px;
  height: 800px;
  margin: auto;
  position: relative;
}

.tech-0 {
  position: absolute;
  left: 44%;
  top: 3%;
}

.tech-1 {
  position: absolute;
  left: 8%;
  top: 42%;
}

.tech-2 {
  position: absolute;
  right: 6%;
  top: 43%;
}

.tech-head {
  font-size: 16px;
  font-weight: 500;
}

.tech-dn {
  position: absolute;
  bottom: 5%;
}

.dss {
  background: #376aff;
  height: 70px;
  color: #fff;
  border-radius: 10px;
}

.font-sml {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/prodCore/coreTech.vue